export default "__VITE_ASSET__DofFPNSW__"